import { AquatecSystemApiEnum } from 'submodules/nerit-aquatec-sdk/common/AquatecSystemApiEnum'
import { QAQCExecuteRequestDTO } from 'submodules/nerit-aquatec-sdk/services/charts/dtos/requests/QAQCExecuteRequestDTO'
import { QAQCSearchRequestDTO } from 'submodules/nerit-aquatec-sdk/services/qaqc/dtos/request/QAQCSearchRequestDTO'
import { QAQCExecutionFilterResponseDTO } from 'submodules/nerit-aquatec-sdk/services/qaqc/dtos/response/QAQCExecutionFilterResponseDTO'
import { QAQCItemResponseDTO } from 'submodules/nerit-aquatec-sdk/services/qaqc/dtos/response/QAQCItemResponseDTO'
import { QAQCListItemResponseDTO } from 'submodules/nerit-aquatec-sdk/services/qaqc/dtos/response/QAQCListItemResponseDTO'
import { ListResponseDTO } from 'submodules/nerit-framework-utils/sdk-utils/dtos/response/ListResponseDTO'
import { HttpMethodEnum } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/enums/HttpMethodEnum'
import { RequestConfigTP } from 'submodules/nerit-framework-utils/sdk-utils/request-manager/types/RequestConfigTP'

export class QAQCRequests {

	public static CONTROLLER_ROOT = 'qaqc'
	public static SEARCH_EP = 'search'
	public static EXECUTE_IONIC_BALANCE = 'execute-ionic-balance'
	public static EXECUTE_ANOMALY_EVALUATION = 'execute-anomaly-evaluation'
	public static CANCEL_EP = 'cancel/:code'
	public static GET_EP = 'get/:code'
	public static GET_EXECUTION_FILTER_EP = 'get-execution-filter/:code'
	public static EXPORT_QAQC_RESULT_EP = 'export-result/:code'

	static search = (dto: QAQCSearchRequestDTO): RequestConfigTP<ListResponseDTO<QAQCListItemResponseDTO>> => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${QAQCRequests.CONTROLLER_ROOT}/${QAQCRequests.SEARCH_EP}`,
		method: HttpMethodEnum.GET,
		params: dto,
	})

	static executeIonicBalance = (dto: QAQCExecuteRequestDTO): RequestConfigTP<void> => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${QAQCRequests.CONTROLLER_ROOT}/${QAQCRequests.EXECUTE_IONIC_BALANCE}`,
		method: HttpMethodEnum.POST,
		params: dto,
	})

	static executeAnomalyEvaluation = (dto: QAQCExecuteRequestDTO): RequestConfigTP<void> => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${QAQCRequests.CONTROLLER_ROOT}/${QAQCRequests.EXECUTE_ANOMALY_EVALUATION}`,
		method: HttpMethodEnum.POST,
		params: dto,
	})

	static cancel = (code: number): RequestConfigTP<void> => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${QAQCRequests.CONTROLLER_ROOT}/${QAQCRequests.CANCEL_EP.replace(':code', code.toString())}`,
		method: HttpMethodEnum.PUT,
	})

	static get = (code: number): RequestConfigTP<QAQCItemResponseDTO> => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${QAQCRequests.CONTROLLER_ROOT}/${QAQCRequests.GET_EP.replace(':code', code.toString())}`,
		method: HttpMethodEnum.GET,
	})

	static getExecutionFilter = (code: number): RequestConfigTP<QAQCExecutionFilterResponseDTO> => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${QAQCRequests.CONTROLLER_ROOT}/${QAQCRequests.GET_EXECUTION_FILTER_EP.replace(':code', code.toString())}`,
		method: HttpMethodEnum.GET,
	})

	static exportResult = (code: number): RequestConfigTP<'blob'> => ({
		baseUrlType: AquatecSystemApiEnum.AQUATEC_API,
		url: `${QAQCRequests.CONTROLLER_ROOT}/${QAQCRequests.EXPORT_QAQC_RESULT_EP.replace(':code', code.toString())}`,
		method: HttpMethodEnum.GET,
		responseType: 'blob',
	})

}
